
























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import TaskApi from '@/api/task.ts'

@Component
export default class manualCard extends Vue {
	private manual2Injured: boolean = true
	private isManualConfigurable: boolean = false

	@Prop()
	private data: any

	@Watch('manual2Injured', { immediate: true })
	private onManual2Injured() {
		this.$emit('manual2Injured', this.manual2Injured)
	}

	private changeManual2Injured() {
		this.manual2Injured = !this.manual2Injured
	}

	private activated() {
		this.$emit('manual2Injured', this.manual2Injured)
	}

	private async created() {
		let sendManual = await TaskApi.isSendManual(this.data.insuranceType)
		this.manual2Injured = sendManual.data
		let configurable = await TaskApi.isManualConfigurable(
			this.data.insuranceType
		)
		this.isManualConfigurable = configurable.data
	}
}
